import styled from "@emotion/styled";
import { withConfig } from "src/withConfig";

export const Message = withConfig(theme => styled('p', { label: 'Message' })`
        font-size: ${theme.star.fontSize.regular};
        line-height: 1.4;
        font-weight: ${theme.star.fontWeight.bold};
        margin: 32px 0 0 0;
        text-align: center;
    `
);